import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col rounded-md w-1/2 bg-white border border-gray-lp-1400 p-4 gap-y-2" }
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = { class: "flex flex-row items-center gap-x-4 overflow-y-auto" }
const _hoisted_4 = { class: "text-gray-lp-600 text-12px font-normal font-montserrat mt-2" }
const _hoisted_5 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('urgentDeliveryManagement.upload.recipientName'),
      asterisk: ""
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.form.receiverName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.receiverName = $event)),
            placeholder: 
            _ctx.$t('urgentDeliveryManagement.upload.placeholderRecipientName')
          
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_DataWrapper, {
      class: "mt-1",
      label: _ctx.$t('urgentDeliveryManagement.upload.relation'),
      asterisk: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Select, {
          onOpenSelect: _ctx.onOpenSelectRelation,
          onCloseSelect: _ctx.onCloseSelectRelation,
          isOpenMenu: _ctx.isOpenSelectRelation,
          value: _ctx.form.relation,
          onChooseSelect: _ctx.onSelectRelation,
          dataSelect: _ctx.listRecipientRelation,
          class: "w-full whitespace-no-wrap my-2 z-10"
        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('urgentDeliveryManagement.upload.proofPhoto'),
      asterisk: ""
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              _createVNode(_component_UploadImageTiny, {
                accept: "image/png, image/jpg, image/jpeg",
                titleSize: "10",
                title: "",
                onUpload: _ctx.onUpload,
                onRemove: _ctx.onRemove,
                modelValue: _ctx.form.files[index],
                "onUpdate:modelValue": ($event: any) => (_ctx.form.files[index] = $event),
                maxSize: 5,
                multipleIndex: index
              }, null, 8, ["onUpload", "onRemove", "modelValue", "onUpdate:modelValue", "multipleIndex"])
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("urgentDeliveryManagement.upload.photoSizeRequirement")), 1)
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_LpButton, {
        disabled: _ctx.isDisableConfirm,
        onClick: _ctx.showConfirmation,
        customClass: "px-10 py-2 w-32",
        textColor: "white",
        title: _ctx.$t('urgentDeliveryManagement.upload.updatePod'),
        isWidthFull: ""
      }, null, 8, ["disabled", "onClick", "title"])
    ])
  ]))
}